import { getDefaultValue, simpleAlert, SubLine } from "components/CommonLib/CommonLib";
import CheckBox from "components/LabelInput/CheckBox";
import ComboBox from "components/LabelInput/ComboBox";
import Label from "components/LabelInput/Label";
import MultiComboBox from "components/LabelInput/MultiComboBox";
import SearchComboBox from "components/LabelInput/SearchComboBox";
import TextField from "components/LabelInput/TextField";
import NormalBtn from "components/NewButton/NormalBtn";
import { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import {
  SearchConditionBox,
  SearchContainer,
  SearchMultiConditionBox,
  SearchRowBox,
} from "../style";

const SearchCardRow1 = ({ onClickSearch, searchParam, setSearchParam, phone }) => {
  const labelWidth = "5.5rem";
  const labelWidthShort = "4rem";
  const textBoxWidth = "14rem";
  const phoneInputBoxWidth = "5.5rem";
  const phoneRef1 = useRef();
  const phoneRef2 = useRef();
  const phoneRef3 = useRef();

  // 전화번호 입력 이벤트 (모든 칸)
  const onInputPhone = () => {
    let res = "";

    if (phone.p1 && !phone.p2 && phone.p3) {
      res = "err";
    } else {
      res = phone.p1 + "-" + phone.p2 + "-" + phone.p3;
    }
    res = res.replace("--", "-");

    setSearchParam((cur) => {
      const obj = { ...cur };
      obj.member_base.phone = res;
      return obj;
    });
  };

  return (
    <SearchContainer>
      <Label labelText="검색 조건: 회원 정보" fontWeight="bold" justifyContent="flex-start" />
      <SearchRowBox
        onKeyDown={(e) => {
          if (e.key === "Enter") onClickSearch(1);
        }}
      >
        <SearchConditionBox>
          <TextField
            labelWidth={labelWidth}
            textBoxWidth={textBoxWidth}
            defaultValue={searchParam.member_base.member_no}
            labelText="회원번호"
            onChangeCallback={(e) => {
              setSearchParam((cur) => {
                const obj = { ...cur };
                obj.member_base.member_no = e;
                return obj;
              });
            }}
          />
        </SearchConditionBox>
        <SearchConditionBox>
          <TextField
            labelWidth={labelWidth}
            textBoxWidth={textBoxWidth}
            defaultValue={searchParam.member_base.member_name}
            labelText="이름"
            onChangeCallback={(e) => {
              setSearchParam((cur) => {
                const obj = { ...cur };
                obj.member_base.member_name = e;
                return obj;
              });
            }}
          />
        </SearchConditionBox>
        <SearchConditionBox>
          <TextField
            inputRef={phoneRef1}
            labelWidth={labelWidthShort}
            textBoxWidth={phoneInputBoxWidth}
            textMarginRight="0.1rem"
            labelText="연락처"
            defaultValue={phone.p1}
            maxLength={3}
            onChangeCallback={(e) => {
              phone.p1 = e;
              onInputPhone();
              if (phone.p1.length === 3) {
                phoneRef2.current.select();
              }
            }}
          />
          <TextField
            inputRef={phoneRef2}
            textBoxWidth={phoneInputBoxWidth}
            textMarginRight="0.1rem"
            labelMarginRight="0.1rem"
            labelText="-"
            maxLength={4}
            defaultValue={phone.p2}
            onChangeCallback={(e) => {
              phone.p2 = e;
              onInputPhone();
              if (phone.p2.length === 4) {
                phoneRef3.current.select();
              }
            }}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                onClickSearch(1);
              } else if (e.key === "Backspace" && !phone.p2) {
                phoneRef1.current.select();
              }
            }}
          />
          <TextField
            inputRef={phoneRef3}
            textBoxWidth={phoneInputBoxWidth}
            textMarginRight="0.1rem"
            labelMarginRight="0.1rem"
            labelText="-"
            maxLength={4}
            defaultValue={phone.p3}
            onChangeCallback={(e) => {
              phone.p3 = e;
              onInputPhone();
            }}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                onClickSearch(1);
              } else if (e.key === "Backspace" && !phone.p3) {
                phoneRef2.current.select();
              }
            }}
          />
        </SearchConditionBox>
      </SearchRowBox>
    </SearchContainer>
  );
};

const SearchCardRow2 = ({ searchParam, setSearchParam, ptBranch, onClickSearch, statusData }) => {
  const labelWidth = "5.5rem";
  const labelWidthShort = "4rem";
  const textBoxWidth = "14rem";

  // 첫 지점 검색 조건 세팅
  useEffect(() => {
    if (ptBranch.branch_list[0] && searchParam.branch_info.branch_id === "") {
      setSearchParam((prev) => {
        return { ...prev, branch_info: ptBranch.branch_list[0] };
      });
    }
  }, [ptBranch]);

  return (
    <SearchContainer
      onKeyDown={(e) => {
        if (e.key === "Enter") onClickSearch(1);
      }}
    >
      <Label labelText="검색 조건: 상세" fontWeight="bold" justifyContent="flex-start" />
      <SearchRowBox>
        <SearchConditionBox>
          <SearchComboBox
            labelWidth={labelWidth}
            comboItemWidth={textBoxWidth}
            data={ptBranch.branch_name_list}
            defaultValue={getDefaultValue("combo", searchParam.branch_info.branch_name)}
            labelText="지점"
            onChangeCallback={(e, v) => {
              const branch = ptBranch.branch_list.find((el) => el.branch_name === v);
              setSearchParam((cur) => {
                return { ...cur, branch_info: branch };
              });
            }}
          />
        </SearchConditionBox>
        <SearchConditionBox>
          <ComboBox
            labelWidth={labelWidth}
            comboItemWidth={textBoxWidth}
            data={["전체", "미배정", "배정"]}
            defaultValue={searchParam.pt_info.is_assigned || "전체"}
            labelText="배정 상태"
            onChangeCallback={(e) => {
              setSearchParam({
                ...searchParam,
                staff_text_name: "",
                pt_info: {
                  ...searchParam.pt_info,
                  is_assigned: e.target.value,
                  class_status: "",
                },
              });
            }}
          />
        </SearchConditionBox>
        <SearchMultiConditionBox>
          <MultiComboBox
            labelWidth={labelWidthShort}
            comboItemWidth={"22rem"}
            labelText="PT 상태"
            option={statusData}
            defaultValue={searchParam.pt_info.root_status}
            onChangeCallback={(e, valueArr, reason) => {
              setSearchParam((cur) => {
                const obj = { ...cur };
                obj.pt_info.root_status = valueArr;
                return obj;
              });
            }}
          />
        </SearchMultiConditionBox>
      </SearchRowBox>
      <SearchRowBox>
        <SearchConditionBox>
          <TextField
            labelText="수업 담당자"
            labelWidth={labelWidth}
            textBoxWidth={textBoxWidth}
            defaultValue={searchParam.staff_text_name}
            onChangeCallback={(e) => {
              setSearchParam({
                ...searchParam,
                staff_text_name: e,
                pt_info: { ...searchParam.pt_info, is_assigned: "배정" },
              });
            }}
          />
        </SearchConditionBox>
        <SearchConditionBox>
          <ComboBox
            labelWidth={labelWidth}
            comboItemWidth={textBoxWidth}
            data={["전체", "수업완료", "노쇼"]}
            labelText="PT 수업상태"
            defaultValue={searchParam.pt_info.class_status || "전체"}
            onChangeCallback={(e) => {
              let value = e.target.value;
              if (value === "전체") {
                value = "";
              }

              setSearchParam({
                ...searchParam,
                pt_info: {
                  ...searchParam.pt_info,
                  class_status: value,
                  is_assigned: "배정",
                },
              });
            }}
          />
        </SearchConditionBox>
        <SearchConditionBox>
          <CheckBox
            labelText="퇴사자 수업 보기"
            transform={"scale(1.2)"}
            ItemMarginLeft={"-0.25rem"}
            marginRight={"0.3rem"}
            marginTop={"0rem"}
            defaultValue={searchParam.manager_info.is_resigned}
            onChangeCallback={(e) => {
              setSearchParam((cur) => {
                const obj = { ...cur };
                obj.manager_info.is_resigned = e.checked;
                return obj;
              });
            }}
          />
        </SearchConditionBox>
      </SearchRowBox>
    </SearchContainer>
  );
};

const PtSearchCard = ({
  searchParam,
  setSearchParam,
  resetSearchParam,
  ptBranch,
  phone,
  onClickSearch,
  statusData,
}) => {
  const storesDispatch = useDispatch();

  return (
    <div>
      <SearchCardRow1
        onClickSearch={onClickSearch}
        phone={phone}
        searchParam={searchParam}
        setSearchParam={setSearchParam}
      />
      <SearchCardRow2
        onClickSearch={onClickSearch}
        searchParam={searchParam}
        setSearchParam={setSearchParam}
        ptBranch={ptBranch}
        statusData={statusData}
      />

      <div
        style={{
          marginTop: "0.7rem",
          display: "flex",
          justifyContent: "flex-end",
          gap: "0.3rem",
        }}
      >
        <NormalBtn
          name="초기화"
          theme="white"
          width="6.25rem"
          onClick={() => {
            resetSearchParam();
          }}
        />

        <NormalBtn
          name="검색"
          width="6.25rem"
          onClick={() => {
            onClickSearch(1, false);
          }}
        />
      </div>
      <SubLine />
      <div
        style={{
          display: "flex",
          justifyContent: "end",
        }}
      >
        <NormalBtn
          name="엑셀 다운로드"
          theme="green"
          onClick={() => {
            simpleAlert(
              storesDispatch,
              "알림",
              `${searchParam.branch_info.branch_name}_PT_목록.xlsx \n엑셀 다운로드 하시겠습니까?`,
              false,
              undefined,
              () => {
                onClickSearch(1, true);
              },
              () => {},
            );
          }}
        />
      </div>
    </div>
  );
};
export default PtSearchCard;
